export enum AmpEventSourceTypeCommunity {
  COMMUNITY = 'SalesCE'
}
